import React from 'react';

type Props = {
  /** Заголовок слева */
  title: React.ReactNode;
  /** Блок справа (иконки/кнопки) */
  addButton?: React.ReactNode;
  /** НОВОЕ: центральный блок (табы / свитчер) */
  center?: React.ReactNode;
};

const ProductHeader: React.FC<Props> = ({ title, addButton, center }) => {
  return (
    <div
      style={{
        // якорь и сетка на 3 зоны: слева — auto, центр — 1fr, справа — auto
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        padding: '12px 20px',
        borderBottom: '3px solid #b70000',
        borderRadius: '8px 8px 0 0',
        marginBottom: 20,
        gap: 12,
      }}
    >
      {/* слева: заголовок */}
      <div style={{ minWidth: 0 }}>
        {typeof title === 'string' ? <h2 style={{ margin: 0 }}>{title}</h2> : title}
      </div>

      {/* центр: свитчер */}
      <div
        style={{
          justifySelf: 'center',
          display: 'inline-flex',
          minWidth: 0,
        }}
      >
        {center ?? null}
      </div>

      {/* справа: действия */}
      <div style={{ justifySelf: 'end' }}>{addButton}</div>
    </div>
  );
};

export default ProductHeader;
